export function isNumeric(value: string): boolean {
  const num = Number(value);

  return value.trim() !== '' && !isNaN(num) && isFinite(num);
}
